import { getEnergyConsumption, getEnergyDevices, getEnergyHistory } from '@/api/energy';
import { useQuery } from '@tanstack/react-query';

export function useEnergyDevices({ enabled = true }: { enabled?: boolean } = {}) {
  const query = useQuery({
    queryKey: ['energy-devices'],
    queryFn: getEnergyDevices,
    enabled,
    staleTime: 0,
  });

  return { query };
}

export function useEnergyHistory({
  deviceId,
  startDate,
  endDate,
  enabled,
}: {
  deviceId: string;
  startDate: string;
  endDate: string;
  enabled?: boolean;
}) {
  const query = useQuery({
    queryKey: ['energy-history', deviceId, startDate, endDate],
    queryFn: () => getEnergyHistory({ deviceId, startDate, endDate }),
    enabled: Boolean(deviceId) && enabled !== false,
    staleTime: 0,
  });

  return { query };
}

export function useEnergyConsumption({
  deviceId,
  startDate,
  endDate,
  enabled,
}: {
  deviceId: string;
  startDate: string;
  endDate: string;
  enabled?: boolean;
}) {
  const query = useQuery({
    queryKey: ['energy-consumption', deviceId, startDate, endDate],
    queryFn: () => getEnergyConsumption({ deviceId, startDate, endDate }),
    enabled: Boolean(deviceId) && enabled !== false,
    staleTime: 0,
  });

  return { query };
}
